import { basicListAddEditDltInitialState } from '../../../../../stateManagement/reduxUtil';
import { commonTypes } from '../../../../common/redux/actions/commonActions';
import { genEditRelationshipValActionType } from '../actions/actionTypes';

const GenEditRelationshipVal = (state = { ...basicListAddEditDltInitialState }, action = null) => {
  switch (action.type) {
    case genEditRelationshipValActionType.RESET_GERV_LOOKUPDATA:
      return {
        ...state,
        pageLevelLookupData: action.data,
      };
    case genEditRelationshipValActionType.GET_GERV_DESC_RESPONSE:
      return {
        ...state,
        detailData: action.data,
        detailRequestError: null,
        detailRequestProcessedOn: new Date(),
        loading: false,
      };
    case genEditRelationshipValActionType.RESET_UPSERT_ERROR:
      return {
        ...state,
        upsertRequestError: [],
      };
    // reset Upset Value
    case genEditRelationshipValActionType.RESET_UPSERT_VALUE:
      return {
        ...state,
        upsertRequest: action.data.upsertRequest,
        upsertRequestError: action.data.upsertRequestError,
        upsertRequestedOn: action.data.upsertRequestedOn,
        upsertRequestProcessedOn: action.data.upsertRequestProcessedOn,
        upsertData: action.data.upsertData,
      };
    // reset Delete Value
    case genEditRelationshipValActionType.RESET_DELETE_VALUE:
      return {
        ...state,
        deleteRequest: action.data.deleteRequest,
        deleteRequestError: action.data.deleteRequestError,
        deleteRequestedOn: action.data.deleteRequestedOn,
        deleteRequestProcessedOn: action.data.deleteRequestProcessedOn,
        deleteData: action.data.deleteData,
      };
    case genEditRelationshipValActionType.SET_GERV_DETAILS_RESPONSE:
      return {
        ...state,
        subModuledetails: action.data,
      };
    case commonTypes.RESETSTORE:
      return basicListAddEditDltInitialState;
    default:
      return state;
  }
};

export default GenEditRelationshipVal;
